import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IGamesByIDsRestaurantsForGames } from 'types';
import {
	IGameAssignmentContext,
	GameAssignmentContext,
} from '../../../../../gameAssignmentState/gameAssignmentContext';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import style from './Game.module.scss';

interface IGame {
	data: IGamesByIDsRestaurantsForGames[];
	restaurantID: string;
}

const Game: React.FC<IGame> = ({ data, restaurantID }) => {
	const { deleteGameFromRestaurant } = useContext<IGameAssignmentContext>(GameAssignmentContext);

	return (
		<div data-test="Game">
			{data.map((el) => {
				const containerClasses = classNames(style.container, { [style.addedItem]: !el.restaurantAddress });

				return (
					<div className={containerClasses} key={el.gameId + 'gameTab'}>
						<Text className={style.name} translationKey={el.gameName} withTooltip={true} />
						<Text className={style.customer} translationKey={el.customerName} withTooltip={true} />
						<Text className={style.address} translationKey={el.restaurantAddress} withTooltip={true} />
						<svg
							className={style.closeIcon}
							onClick={() => deleteGameFromRestaurant(restaurantID, el.gameId)}>
							<use xlinkHref={`${breadcrumbs}#close`} />
						</svg>
					</div>
				);
			})}
		</div>
	);
};

export default Game;
